module.exports = __webpack_public_path__ + "img/13.6c43b516.png";